function notificationIsAllowed() {
  return Notification.requestPermission().then(
    (status) => status === "granted"
  );
}
function sendNotification(title, body) {
  notificationIsAllowed()
    .then((allowed) => {
      if (!allowed) return;
      const notification = new Notification(title, { body });
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    })
    .catch((err) => {
      console.error(err);
    });
}
module.exports = {
  sendNotification
}
